@if (isDisplayed$() | async) {
  <div>
    @if (description) {
      <p>{{description | loadTemplateData$ | async}}</p>
    }
    <mat-chip-set>
      @for (chip of chips; track chip) {
        <mat-chip mat-raised-button (click)="selectChip(chip)" color="accent">
          {{ chip }}
          @if (hasMultiple) {
            <mat-icon matChipTrailingIcon>add</mat-icon>
          }
        </mat-chip>
      }
    </mat-chip-set>
  </div>
}